import { useMemo } from "react";
import type { HotelReservationCardComponentProps } from "@b2bportal/core-hotels/overridable";
import { useI18nContext } from "@hopper-b2b/i18n";
import { useHotelReservationCard as useCoreHotelReservationCard } from "@tenant/hotels";
import dayjs from "dayjs";
import { formatDateWithWeekday } from "@/utilities/formatDate";

export const useHotelReservationCard = (
  props: HotelReservationCardComponentProps
) => {
  const { reservation } = props;
  const { formatDateTime, t } = useI18nContext();
  const coreResult = useCoreHotelReservationCard(props);

  return useMemo(
    () => ({
      ...coreResult,
      text: {
        ...coreResult.text,
        dates: t("core-hotels.postBooking.summaryCard.dates", {
          fromDate: formatDateWithWeekday(
            dayjs(reservation.checkInDate).toDate(),
            formatDateTime
          ),
          untilDate: formatDateWithWeekday(
            dayjs(reservation.checkOutDate).toDate(),
            formatDateTime
          ),
        }),
      },
    }),
    [coreResult, reservation, formatDateTime, t]
  );
};
